import { CBadge } from '@coreui/react';
import React from 'react';
import PropTypes from 'prop-types';

const PetitionsLabels = ({ labels, hasDuplicates }) => (
  <>
    {labels.map((label) => (
      <CBadge style={{ background: label.color }} className="text-white mr-1" key={label.id}>
        {label.name}
      </CBadge>
    ))}
    {!!hasDuplicates && (
      <CBadge style={{ background: '#88E684' }} className="text-white mr-1">
        May Contain Duplicate
      </CBadge>
    )}
  </>
);

PetitionsLabels.propTypes = {
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      color: PropTypes.string,
    }),
  ).isRequired,
  hasDuplicates: PropTypes.number.isRequired,
};

export default PetitionsLabels;
